import React from "react";

const FilterContext = React.createContext({
    summaryQuery: null,
});

export default FilterContext;
